'use strict';
import api from 'utils/api';
import createFormatCache from 'intl-format-cache';
import IntlMessageFormat from 'intl-messageformat';
import IntlRelativeFormat from 'intl-relativeformat';
import get from 'lodash/object/get';
import flux from 'utils/flux';
import store from 'store';
import mb_consts from 'utils/mb_consts';

const TranslationsSource = (alt) => {
    return {
        switchLanguage: {
            remote( state, language ) {
                const isAuthenticated = flux.getStore('app').isAuthenticated();
                if (isAuthenticated) {
                    return api.post('edit_language', {
                        language
                    }).then(() => language);
                } else {
                    return new Promise((resolve) => resolve(language));
                }
            },
            success: alt.getActions('translations').setLanguage,
            error: alt.getActions('app').onError
        }
    }
}
export default class TranslationsStore {
    constructor() {
        this.bindActions(this.alt.getActions('translations'));
        this.registerAsync(TranslationsSource);

        // ie8 intl polyfill
        if (!global.Intl) {
            global.Intl = require('intl');
        }

        this.userLocale = store.get(mb_consts.STORE_LANGUAGE_KEY) || undefined;

        this.messages = {};
    }

    static getFormattedMessage(path, values) {
        var state = this.getState();
        var msg = this.getIntlMessage(path);

        var message = state.messageFormat(msg, state.locales, state.formats);
        return message.format(values);
    }

    static getFormattedDate(date, options) {
        var state = this.getState();
        date = new Date(date);
        // assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
        return state.dateTimeFormat(state.locales, options).format(date);
    }

    static getFormatRelative(date, options, formatOptions) {
        var state = this.getState();
        date = new Date(date);
        // assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
        return state.relativeFormat(state.locales, options).format(date, formatOptions);
    }

    static getMessages(path) {
        if (!path) {
            return this.getState().messages;
        } else {
            return get(this.getState().messages, path);
        }
    }

    static getUserLocale() {
        return this.getState().userLocale;
    }

    static getAvailableLanguages() {
        return this.getState().availableLanguages;
    }

    static getIntlMessage(path, returnEmtpy = false) {
        var messages = this.getState().messages;
        var message  = get(messages, path);

        if (message === undefined && returnEmtpy === false) {
            //console.error('Could not find Intl message: ' + path);
            return path;
        }

        return message;
    }

    onAddLocaleData(localData) {
        IntlMessageFormat.__addLocaleData(localData);
        IntlRelativeFormat.__addLocaleData(localData);

        // Create a cached copy
        this.numberFormat   = createFormatCache(global.Intl.NumberFormat);
        this.dateTimeFormat = createFormatCache(global.Intl.DateTimeFormat);
        this.messageFormat  = createFormatCache(IntlMessageFormat);
        this.relativeFormat = createFormatCache(IntlRelativeFormat);
    }

    onAddMessages(localData) {
        this.formats = localData.formats;
        this.messages = localData.messages;
        this.locales = localData.locales;
    }

    onSetLanguage(locale, reload = true) {
        this.userLocale = locale;
        store.set(mb_consts.STORE_LANGUAGE_KEY, locale);
        if (reload) {
            window.location.reload(false)
        }
    }

    onSetAvailableLanguages(availableLanguages) {
        this.availableLanguages = availableLanguages
    }
}



// WEBPACK FOOTER //
// ./app/stores/translationsStore.js